export default "__VITE_ASSET__BIoPah0V__"